// Adds Authorization bearer token, retries once on 401 by refreshing session, and surfaces persistent auth errors.
// Nuxt auto-imports defineNuxtPlugin and composables

export default defineNuxtPlugin((nuxtApp) => {
  const { getAuthToken, refreshSession } = useAuthSession()

  nuxtApp.$fetch = $fetch.create({
    async onRequest({ options }) {
      if (!options.headers) options.headers = {}
      const headers = options.headers as Record<string, string>
      if (!headers.Authorization && !headers.authorization) {
        const token = await getAuthToken(false)
        if (token) headers.Authorization = `Bearer ${token}`
      }
    },
    async onResponseError(ctx) {
      if (ctx.response.status === 401 && !ctx.request?.context?.retried) {
        ctx.request.context = { ...(ctx.request.context || {}), retried: true }
        const refreshed = await refreshSession()
        if (refreshed) {
          const token = await getAuthToken(false)
          if (token) {
            const headers = (ctx.request.options.headers || {}) as Record<string, string>
            headers.Authorization = `Bearer ${token}`
            ctx.request.options.headers = headers
          }
          return await $fetch.raw(ctx.request.request, ctx.request.options)
        }
      }
      throw ctx.error
    },
  })
})
